import { useClientTimezone, useServerTimezone } from "@/hooks/use-timezone";
import { formatDate } from "@/utils/format-date";
import { ClientOnly } from "@tanstack/react-router";
import type { CSSProperties } from "react";

export default function FormattedDate(props: {
  className?: string;
  style?: CSSProperties;
  format?: string;
  date: string;
  isSSR?: boolean;
}) {
  const serverTimezone = useServerTimezone();
  const clientTimezone = useClientTimezone();
  const render = (timezone?: string) => {
    return (
      <time
        className={props.className}
        style={props.style}
        dateTime={props.date}
      >
        {formatDate(props.date, props.format, { timezone })}
      </time>
    );
  };
  if (!props.isSSR) return render();
  // the server knows the client timezone. safe to render
  else if (clientTimezone) return render(clientTimezone);
  else {
    return (
      <ClientOnly fallback={render(serverTimezone)}>{render()}</ClientOnly>
    );
  }
}
